export default "__VITE_ASSET__f3a6a3da__"